'use strict'

/**
 * @module tips
 */

const CLASS_IDENT = 'js-ident-camping'

const ATTRIBUTE_ID = 'data-campsite-id'

const API_HISTORY = '/api/stats/also-viewed'

const LOCAL_STORAGE = 'cf_history'

const TEMPLATE = '<li><a href="{{href}}" title="{{title}}">'
                 + '<figure class="visu-art" itemprop="image">'
                 + '<picture><img src="{{src}}" alt="" width="300" height="190"></picture>'
                 + '</figure>'
                 + '<div class="content-bloc-art">'
                 + '<h3 class="camp-name">'
                 + '<span>{{name}}</span><span class="stars">{{stars}}</span>'
                 + '</h3>'
                 + '<span class="cf-city-dep"><span class="txt"><strong>{{cityname}},</strong>'
                 + ' {{adminname}} ({{admincode}})</span></span>'
                 + '</div>'
                 + '</a></li>'

const TEMPLATE_STAR = '<svg width="12" height="12">'
                       + '<use '
                       + 'xmlns:xlink="http://www.w3.org/1999/xlink" '
                       + 'xlink:href="/svg/sprite.svg#svg-etoile"></use>'
                       + '</svg>'

export default {
  /**
   * @description Initialise history
   * @returns {undefined}
   */
  init() {
    this.userHistoryData = JSON.parse(localStorage.getItem(LOCAL_STORAGE)) || []
    this.currentId = document.getElementsByClassName(CLASS_IDENT).item(0).getAttribute(ATTRIBUTE_ID)
    if (this.isNew()) {
      this.writeHTML()
      this.sendHistory()
    }
  },
  
  isNew() {
    return !this.userHistoryData.find((item) => {
      return item.id === this.currentId
    })
  },
  
  /**
   * @description if more than 1 campsite visited, send all visited campsite id
   * @returns {undefined}
   */
  sendHistory() {
    if (this.userHistoryData.length < 2) {
      return
    }
    
    const headers = new Headers()
    headers.set('Content-Type', 'application/json')
    
    fetch(API_HISTORY,
      {
        method: 'post',
        headers: headers,
        body: JSON.stringify({
          campsite_ids: this.userHistoryData.map((item) => {
            return item.id
          })
        })
      }
    )
  },
  
  /**
   * @description fill TEMPLATE with camping value
   * @returns {undefined}
   */
  writeHTML() {
    let i = 0
    let html = TEMPLATE
    const data = Object.assign({}, {
      href: location.href,
      title: document.title,
      src: document.getElementsByClassName('js-slider').item(0).getElementsByTagName('img').item(0).src,
      stars: ''
    }, JSON.parse(document.getElementsByTagName('main').item(0).getAttribute('data-camping-info')))
    
    while (i < data.starnumber) {
      data.stars += TEMPLATE_STAR
      i++
    }
    delete data.starnumber
    for (let value in data) {
      html = html.replace(`{{${value}}}`, data[value])
    }
  
    this.writeLocalStorage(html)
  },
  
  /**
   * @description Write html in localStorage
   * @params {string} html TEMPLATE with current camping values
   * @returns {undefined}
   */
  writeLocalStorage(html) {
    if (this.userHistoryData) {
      this.userHistoryData.push({
        id: this.currentId,
        html: html
      })
    }
    if (this.userHistoryData.length === 5) {
      this.userHistoryData.shift()
    }
    localStorage.setItem(LOCAL_STORAGE, JSON.stringify(this.userHistoryData))
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/history.js